var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { color: "#0b0b0b" } },
    [
      _c("div", { staticClass: "closeThisMDFe" }, [
        _c("div", { staticClass: "sureYouWantToClose" }, [
          _vm._v(
            _vm._s(_vm.$t("mdfeTranslate.AreYouSureYouWantToCloseThisMDFe"))
          ),
        ]),
        _c("div", [
          _vm._v(
            _vm._s(_vm.$t("mdfeTranslate.ThisOperationWillEndTheCurrentTrip"))
          ),
        ]),
      ]),
      _c("div", { staticClass: "applicableScenarios" }, [
        _vm._m(0),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.ApplicableScenarios"))),
          ]),
          _c("div", [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.ArrivalAtUnloadingState"))),
          ]),
        ]),
      ]),
      _c("el-divider"),
      _c("div", { staticClass: "applicableScenarios" }, [
        _vm._m(1),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.NecessaryConditions"))),
          ]),
          _c("div", [_vm._v(_vm._s(_vm.$t("mdfeTranslate.MustBeCompleted")))]),
        ]),
      ]),
      _c("el-divider"),
      _c("div", { staticClass: "applicableScenarios" }, [
        _vm._m(2),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.UnfinishedEffects"))),
          ]),
          _c("div", [
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$t(
                    "mdfeTranslate.IfNotCompletedCorrespondingUnloadingState"
                  )
                ) + "，"
              ),
            ]),
            _c("span", { staticStyle: { color: "#0c5dd4" } }, [
              _vm._v(
                _vm._s(
                  _vm.$t("mdfeTranslate.newMDFeAuthorizationWillBeBlocked")
                )
              ),
            ]),
          ]),
        ]),
      ]),
      _c("el-divider"),
      _c("div", { staticClass: "operationResultCont" }, [
        _vm._m(3),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "applicableTitle" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.OperationResult"))),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t("mdfeTranslate.AfterClosingYouCanModifyInformation")
              )
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "importantTipsCont" }, [
        _vm._m(4),
        _c("div", { staticClass: "applicableCont" }, [
          _c("div", { staticClass: "importantTips" }, [
            _vm._v(_vm._s(_vm.$t("mdfeTranslate.ImportantTips"))),
          ]),
          _c("div", [
            _vm._v(
              _vm._s(
                _vm.$t(
                  "mdfeTranslate.PleaseConfirmThatItHasArrivedAtTheUnloadingState"
                )
              )
            ),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "60px" } }, [
      _c("i", { staticClass: "el-icon-location" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flagIcon" }, [
      _c("i", { staticClass: "el-icon-s-flag" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "applicableScenariosCont" }, [
      _c("i", { staticClass: "iconfont icon-ziyuanxhdpi" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "applicableScenariosCont" }, [
      _c("i", { staticClass: "el-icon-warning-outline" }),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticStyle: { width: "60px" } }, [
      _c("i", { staticClass: "iconfont icon-a-zu665" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }